import { useState, useEffect } from "react";
import axios from "../customAxios.js";
import InputMask from "react-input-mask";
import * as EmailValidator from "email-validator";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import {
  Button,
  IconButton,
  Typography,
  List,
  ListItem,
  ListItemText,
  Card,
  CardContent,
  Chip,
  Grid,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Alert,
  Autocomplete,
  Snackbar,
} from "@mui/material";
import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineDot,
  TimelineContent,
} from "@mui/lab";
import EditIcon from "@mui/icons-material/Edit";
import CircularProgress from "@mui/material/CircularProgress";
import InventoryIcon from "@mui/icons-material/Inventory";
import DownloadIcon from "@mui/icons-material/Download";
import DeliveryItems from "../components/DeliveryItems.jsx";
import { get_full_address } from "../helpers/addressParser.js";
import {
  get_order_type_label,
  get_order_status_label,
  get_order_source_label,
  get_order_shipping_method_label,
  shippingMethodEnumChoices,
  get_order_provider,
  deliveryStatusEnum,
  deliverySubstatusEnum,
  mapSubtatusToDbName,
  driversChoices,
} from "../helpers/enums.js";
import { regionsAndCommunes } from "../helpers/ChileanAddressesData";
import {
  strDateFormatWithTime,
  filterStatusByOrderType,
} from "../utils/functions";
import { mergePDFSFromUrls } from "../utils/labelService";
import { useAuth } from "../hooks/useAuth.jsx";
import { useDrivers } from "../hooks/useDrivers.jsx";
import { useDeliveryItems } from "../hooks/useDeliveryItems.jsx";
import { useOrderPicking } from "../hooks/useOrderPicking.jsx";

function OrderDetail() {
  const { orderId } = useParams();
  const [order, setOrder] = useState(null);
  const [filteredStatuses, setFilteredStatuses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [originCountry, setOriginCountry] = useState("");
  const [loadingError, setLoadingError] = useState("");

  let navigate = useNavigate();

  const [openEditOrderInfo, setOpenEditOrderInfo] = useState(false);
  const [openEditRecipientInfo, setOpenEditRecipientInfo] = useState(false);
  const [openEditStatus, setOpenEditStatus] = useState(false);

  // values for edit order info
  const [street, setStreet] = useState("");
  const [streetNumber, setStreetNumber] = useState("");
  const [references, setReferences] = useState("");
  const [selectedCommune, setSelectedCommune] = useState(null);
  const [communesOptions, setCommunesOptions] = useState([]);
  const [selectedRegion, setSelectedRegion] = useState(null);
  const [selectedShippingMethod, setSelectedShippingMethod] = useState("");
  const [selectedDriver, setSelectedDriver] = useState({
    label: "",
    value: null,
  });

  const [openDetailModal, setOpenDetailModal] = useState(false);
  const [selectedHistoryStatus, setSelectedHistoryStatus] = useState(null);
  const [newDetailText, setNewDetailText] = useState("");
  const [submitDetailLoading, setSubmitDetailLoading] = useState(false);

  //MX
  const [mxCommune, setMxCommune] = useState("");
  const [mxSettlement, setMxSettlement] = useState("");
  const [mxPostalCode, setMxPostalCode] = useState("");
  const [mxState, setMxState] = useState("");

  const [submitEditOrderInfo, setSubmitEditOrderInfo] = useState(false);
  const [canEditOrderInfo, setCanEditOrderInfo] = useState(false);
  const [warehouses, setWarehouses] = useState([]);
  const [selectedWarehouse, setSelectedWarehouse] = useState("");
  const [notes, setNotes] = useState("");
  const [packages, setPackages] = useState("");
  const [weight, setWeight] = useState("");

  // values for edit delivery status
  const [submitEditDeliveryStatus, setSubmitEditDeliveryStatus] =
    useState(false);
  const [selectedDeliveryStatus, setSelectedDeliveryStatus] = useState(null);
  const [statusDetailComment, setStatusDetailComment] = useState("");
  const [selectedImagesUpload, setSelectedImagesUpload] = useState([]);
  const [selectedDeliverySubstatus, setSelectedDeliverySubstatus] =
    useState(null);
  const [deliverySubstatusOptions, setDeliverySubstatusOptions] = useState([
    { value: "not_specified", label: "No aplica" },
  ]);
  ///////////////// new
  const [imageUrls, setImageUrls] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState(null);

  // values for edit recipient info
  const [recipientName, setRecipientName] = useState("");
  const [contactEmail, setContactEmail] = useState("");
  const [contactPhone, setContactPhone] = useState("");
  const [submitEditRecipientInfo, setSubmitEditRecipientInfo] = useState(false);

  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [messageAlert, setMessageAlert] = useState("");
  const handlePickingError = (errorMessage) => {
    setMessageAlert(errorMessage);
    setOpenErrorAlert(true);
  };

  // courier change (waiting_for_assignment)
  const [availableCouriers, setAvailableCouriers] = useState([]);
  const [selectedCourier, setSelectedCourier] = useState(null);
  const [pendingCourierChange, setPendingCourierChange] = useState(null);
  const [openDispatchConfirm, setOpenDispatchConfirm] = useState(false);
  const [changingCourier, setChangingCourier] = useState(false);

  const { user } = useAuth();
  const planAddons =
    user?.admin_plan?.admin_permissions?.addons ||
    user?.seller_admin_plan?.admin_permissions?.addons ||
    {};
  const hasFulfillmentLite = planAddons.fulfillment_lite === true;
  const hasFulfillmentPro = planAddons.fulfillment_pro === true;

  console.log('plan hasFulfillmentLite: ', hasFulfillmentLite)
  console.log('plan hasFulfillmentPro: ', hasFulfillmentPro)

  const { drivers } = useDrivers();
  const {
    refetchDeliveryItems,
    deliveryItems,
    pagination,
    deliveryItemsCount,
    handleChangePage,
    handleChangeRowsPerPage,
    createDeliveryItem,
    deleteDeliveryItem,
    updateDeliveryItemStatus,
    updateDeliveryItemLogistics,
    setItemsCount,
    loading: loadingDeliveryItems,
    error: errorDeliveryItem,
  } = useDeliveryItems();

  const [selectedImage, setSelectedImage] = useState(null);
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    if (openEditOrderInfo) {
      fetchWarehouses();

      // set order delivery data:
      const selectedMethod = shippingMethodEnumChoices.find(
        (method) => method.value === order.delivery.shipping_method,
      );
      if (selectedMethod) {
        setSelectedShippingMethod(selectedMethod);
      }
      setSelectedWarehouse(order.warehouse);
      setStreet(order.delivery.shipping_address.street);
      setStreetNumber(order.delivery.shipping_address.street_number);
      setReferences(order.delivery.shipping_address.references);
      setNotes(order.notes);
      setPackages(order.delivery.packages);
      setWeight(order.delivery.weight);
      if (originCountry == "(MX)") {
        setMxSettlement(order.delivery.shipping_address.settlement);
        setMxState(order.delivery.shipping_address.region);
        setMxCommune(order.delivery.shipping_address.commune);
        setMxPostalCode(order.delivery.shipping_address.postal_code);
      }
      // Normalize input for comparison
      const communeInput =
        order.delivery.shipping_address.commune.toLowerCase();

      // Find the region that contains the given commune
      const selectedRegion = regionsAndCommunes.find((region) =>
        region.communes.some(
          (commune) =>
            commune.value.toLowerCase() === communeInput ||
            commune.label.toLowerCase() === communeInput,
        ),
      );

      // Find the exact commune inside the found region
      const selectedCommune = selectedRegion
        ? selectedRegion.communes.find(
            (commune) =>
              commune.value.toLowerCase() === communeInput ||
              commune.label.toLowerCase() === communeInput,
          )
        : null;

      if (order.delivery?.driver) {
        setSelectedDriver({
          label: order.delivery?.driver?.full_name,
          value: order.delivery?.driver?.id,
        });
      }
      // Set the selected region and commune
      setSelectedRegion(selectedRegion || null);
      setSelectedCommune(selectedCommune || null);
    }
  }, [openEditOrderInfo]);

  const isSeller = user.user_type.includes("seller");
  // next admin section steps:
  const isAdmin = user.user_type.includes("admin");
  // Check if user is staff
  const isStaff  = user.is_staff;

  const fetchOrder = async () => {
    setLoading(true);
    try {
      const {
        data: { order },
      } = await axios.get(`order_detail/${orderId}/`);
      setFilteredStatuses(filterStatusByOrderType(order));
      setOrder(order);

      // #comentario: con esto queda filtrado por estado "pendiente de asignación"
      // if (order?.delivery?.status === "waiting_for_assignment") {
      //   fetchAvailableCouriers();
      // }
      fetchAvailableCouriers();

      const iso2 = order?.seller?.company?.country_fk?.iso2 ?? "CL";

      if (iso2 === "MX") {
        setOriginCountry("(MX)");
      } else {
        setOriginCountry("(CL)");
      }
      console.log("orden es:", order);
      console.log("pais seller es: ", originCountry);

      setRecipientName(order.recipient);
      setContactEmail(order.contact_email);
      setContactPhone(order.contact_phone);
      setLoadingError("");
      setCanEditOrderInfo(
        order.mixed_status === "in_preparation" &&
          (order.type === "delivery" || order.type === "delivery_fulfillment"),
      );
    } catch (error) {
      console.error(`Ocurrió un error al cargar la orden: ${error}`);
      setLoadingError("Ocurrió un error al cargar la orden");
    } finally {
      setLoading(false);
    }
  };

  const fetchAvailableCouriers = async () => {
    try {
      const { data } = await axios.get("companies/available_couriers/");
      setAvailableCouriers(data);
    } catch (error) {
      console.error("Error al cargar couriers disponibles:", error);
    }
  };

  const handleCourierChange = async (newCourierOption) => {
    if (!newCourierOption) return;
    setChangingCourier(true);
    try {
      const { data } = await axios.patch(
        `deliveries/${order.delivery.id}/change_courier/`,
        { courier: newCourierOption.courier },
      );
      if (data.status === "dispatching") {
        setPendingCourierChange(newCourierOption);
        setOpenDispatchConfirm(true);
      } else {
        setSelectedCourier(newCourierOption);
        fetchOrder();
      }
    } catch (error) {
      console.error("Error al cambiar courier:", error);
      setMessageAlert(
        error.response?.data?.error || "Ocurrió un error al cambiar el courier",
      );
      setOpenErrorAlert(true);
    } finally {
      setChangingCourier(false);
    }
  };

  const handleConfirmDispatch = () => {
    setOpenDispatchConfirm(false);
    setSelectedCourier(pendingCourierChange);
    setPendingCourierChange(null);
    fetchOrder();
  };

  const handleCancelDispatch = () => {
    setOpenDispatchConfirm(false);
    setPendingCourierChange(null);
  };

  const handleDispatchPrepared = async () => {
    await axios.post(`deliveries/${order.delivery.id}/dispatch_prepared/`);
    fetchOrder();
  };

  const fetchWarehouses = async () => {
    try {
      const {
        data: { serialized_warehouses },
      } = await axios.get(
        `warehouses/get_company_warehouses/${order.seller.company.id}/`,
      );
      setWarehouses(serialized_warehouses);
    } catch (error) {
      console.error(`Ocurrió un error al cargar las bodegas: ${error}`);
      setLoadingError("Ocurrió un error al cargar las bodegas");
    }
  };

  const {
    pickingQuantities,
    submittingProductId,
    handleIncrementQuantity,
    handleDecrementQuantity,
    handlePrepareProductIndividual,
  } = useOrderPicking(order, fetchOrder, handlePickingError);

  useEffect(() => {
    fetchOrder();
  }, []);

  const handleSaveEditOrderInfo = () => {
    setSubmitEditOrderInfo(true);
    if (
      originCountry == "(CL)" &&
      street !== "" &&
      streetNumber !== "" &&
      selectedRegion !== null &&
      selectedCommune !== null &&
      selectedShippingMethod !== null &&
      packages !== null &&
      packages > 0 &&
      weight !== null &&
      weight > 0 &&
      selectedWarehouse !== null
    ) {
      const data = {
        action: "shipping",
        id: order.id,
        shipping_method: selectedShippingMethod?.value,
        warehouse: selectedWarehouse?.id,
        notes: notes,
        packages: packages,
        weight: weight,
        billing_address: {
          country: order.seller.company.country_fk?.id,
          street: street,
          street_number: streetNumber,
          commune: selectedCommune.value,
          region: selectedRegion.value,
        },
        delivery: {
          driver_id: selectedDriver?.value || null,
        },
      };
      updateOrderInfo(data);
    } else if (
      originCountry == "(MX)" &&
      street !== "" &&
      streetNumber !== "" &&
      selectedShippingMethod !== null &&
      packages !== null &&
      packages > 0 &&
      weight !== null &&
      weight > 0 &&
      selectedWarehouse !== null
    ) {
      const data = {
        action: "shipping",
        id: order.id,
        shipping_method: selectedShippingMethod?.value,
        warehouse: selectedWarehouse?.id,
        notes: notes,
        packages: packages,
        weight: weight,
        billing_address: {
          country: order.seller.company.country_fk?.id,
          street: street,
          street_number: streetNumber,
          commune: mxCommune,
          settlement: mxSettlement,
          postal_code: mxPostalCode,
          region: mxState,
        },
        delivery: {
          driver_id: selectedDriver?.value || null,
        },
      };
      updateOrderInfo(data);
    }
  };

  const handleSaveEditDeliveryStatus = () => {
    setSubmitEditDeliveryStatus(true);
    const data = {
      status: selectedDeliveryStatus.value,
      substatus: mapSubtatusToDbName(selectedDeliverySubstatus.value),
      details: statusDetailComment,
      image_urls: imageUrls,
    };
    updateDeliveryStatus(data);
  };

  const updateOrderInfo = async (data) => {
    try {
      await axios.put("update_order_info/", data);
      fetchOrder();
      setOpenEditOrderInfo(false);
      setSubmitEditOrderInfo(false);
      setOpenEditRecipientInfo(false);
      setSubmitEditRecipientInfo(false);
    } catch (error) {
      console.error(
        `Ocurrió un error al actualizar la información de la orden: ${error}`,
      );
      setLoadingError(
        "Ocurrió un error al actualizar la información de la orden",
      );
    }
  };

  const updateDeliveryStatus = async (data) => {
    try {
      if (
        window.confirm(
          "¿Estas seguro que quieres actualizar todos los estados?\nEsta acción modificara todos los items asociados",
        )
      ) {
        await axios.patch(`update_order_state/${orderId}/`, data);
        fetchOrder();
        setOpenEditStatus(false);
        setSubmitEditDeliveryStatus(false);
        setOpenEditRecipientInfo(false);
        setSubmitEditRecipientInfo(false);
        setOpenEditOrderInfo(false);
        setSubmitEditOrderInfo(false);
        setOpenEditRecipientInfo(false);
        setSubmitEditRecipientInfo(false);
        resetStatusEditForm();
      }
    } catch (error) {
      console.error(
        `Ocurrió un error al actualizar el estado del delivery: ${error}`,
      );
      setLoadingError("Ocurrió un error al actualizar el estado del delivery");
    }
  };

  const handleSaveRecipientInfo = () => {
    setSubmitEditRecipientInfo(true);
    if (recipientName !== "" && contactEmail !== "" && contactPhone !== "") {
      const data = {
        action: "recipient",
        id: order.id,
        recipient: recipientName,
        contact_email: contactEmail,
        contact_phone: contactPhone,
      };
      updateOrderInfo(data);
    }
  };

  const handleSelectedDeliveryStatusChange = (newValue) => {
    setSelectedDeliveryStatus(newValue);
    newValue
      ? setDeliverySubstatusOptions(
          deliverySubstatusEnum.filter(
            (substatus) =>
              substatus.value.includes(newValue.value) ||
              substatus.value === "not_specified",
          ),
        )
      : setDeliverySubstatusOptions([
          { value: "not_specified", label: "No aplica" },
        ]);
  };

  const regionsOptions = regionsAndCommunes.map((region) => ({
    value: region.value,
    label: region.label,
  }));

  const deliveryStatus = deliveryStatusEnum.map((status) => ({
    value: status.value,
    label: status.label,
  }));

  const handleSelectRegion = (event, newValue) => {
    event.preventDefault();
    setSelectedRegion(newValue);
    setSelectedCommune(null);
    const selectedRegionData = regionsAndCommunes.find(
      (region) => region.value === (newValue ? newValue.value : ""),
    );
    const newCommunesOptions = selectedRegionData
      ? selectedRegionData.communes.map((commune) => ({
          value: commune.value,
          label: commune.label,
        }))
      : [];
    setCommunesOptions(newCommunesOptions);
  };

  const handleSelectDeliveryStatus = (event, newValue) => {
    event.preventDefault();
    handleSelectDeliveryStatus(newValue);
    const selectedRegionData = regionsAndCommunes.find(
      (region) => region.value === (newValue ? newValue.value : ""),
    );
    const newCommunesOptions = selectedRegionData
      ? selectedRegionData.communes.map((commune) => ({
          value: commune.value,
          label: commune.label,
        }))
      : [];
    setCommunesOptions(newCommunesOptions);
  };

  const handleDownloadLabel = async () => {
    try {
      let allItems = [];
      if (deliveryItems.length === deliveryItemsCount) {
        allItems = deliveryItems;
      } else {
        const params = {
          page: 1,
          page_size: deliveryItemsCount,
        };
        const {
          data: { results },
        } = await axios.get(`deliveries/${orderId}/delivery_items/list/`, {
          params,
        });
        allItems = results || [];
      }

      const labelUrls = allItems.map((item) => item.label);
      if (labelUrls && labelUrls.length > 0) {
        const mergedPdfBlob = await mergePDFSFromUrls(labelUrls);
        const mergedUrls = URL.createObjectURL(mergedPdfBlob);
        window.open(mergedUrls, "_blank");
      } else {
        throw Error("No se obtuvieron las urls de etiquetas");
      }
    } catch (error) {
      console.error("Error:", error);
      setMessageAlert("Ocurrió un error al descargar la etiqueta");
      setOpenErrorAlert(true);
    }
  };

  const handleCloseAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  //open modal for POD image:

  // Function to open the modal and set the selected image
  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
    setOpenModal(true);
  };

  // Function to close the modal
  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedImage(null);
  };

  // Mocked S3 upload function
  const uploadImageToS3 = async (file) => {
    try {
      const timestamp = new Date().toISOString().replace(/[-T:.Z]/g, "");
      const uniqueFileName = `${orderId}-${
        file.name.split(".")[0]
      }-${timestamp}.${file.name.split(".").pop()}`;

      const formData = new FormData();
      formData.append("file", file);
      formData.append("filename", uniqueFileName);
      const { data } = await axios.post("/upload_pod/", formData);
      return data.file_url;
    } catch (error) {
      console.error(`Error al subir la imagen: ${error.response || error}`);
      setError(error.message || "Ocurrió un error al subir la imagen");
      return null;
    }
  };

  // Handle image selection
  const handleImageSelect = async (event) => {
    const files = Array.from(event.target.files);
    if (files.length + imageUrls.length > 3) {
      setError("You can only upload up to 3 images.");
      return;
    }

    // Filter only valid file types
    const validFiles = files.filter(
      (file) => file.type === "image/png" || file.type === "image/jpeg",
    );

    if (validFiles.length < files.length) {
      setError("Solo formatos PNG y JPG.");
      return;
    }

    setError(null);
    setUploading(true);

    for (const file of files) {
      const imageUrl = await uploadImageToS3(file);
      if (imageUrl) {
        setImageUrls((prev) => [...prev, imageUrl]);
      }
    }

    setUploading(false);
  };

  // Handle image deletion

  const handleRemoveImage = (index) => {
    const updatedImages = imageUrls.filter((_, i) => i !== index);
    setImageUrls(updatedImages);

    // Optional: If you need to delete the image from S3
    if (typeof imageUrls[index] === "string") {
      deleteImageFromS3(imageUrls[index]);
    }
  };

  const deleteImageFromS3 = async (url) => {
    try {
      await axios.delete("delete_pod/", { data: { url } });
      console.log("Image deleted successfully.");
    } catch (error) {
      console.error("Failed to delete the image.", error);
    }
  };

  const resetStatusEditForm = () => {
    setSelectedDeliveryStatus(null); // Reset selected status
    setSelectedDeliverySubstatus(null);
    setDeliverySubstatusOptions([
      { value: "not_specified", label: "No aplica" },
    ]);
    setStatusDetailComment(""); // Clear the detail comment
    setImageUrls([]); // Clear uploaded images
    setError(null); // Clear any errors
  };

  const handleFulfillOrder = async () => {
    try {
      setLoading(true);
      const { data, status } = await axios.patch(
        `deliveries/${order.delivery.id}/fulfill/`,
        {},
      );
      if (status === 200) {
        console.info(data);
        setTimeout(() => {
          window.location.reload(true);
        }, 1000);
      }
    } catch (error) {
      console.error(`[EXCEPTION] ${error}`);
    } finally {
      setLoading(false);
    }
  };

  const handleSaveStatusDetail = async () => {
    if (!selectedHistoryStatus || !order?.delivery?.id) return;
    setSubmitDetailLoading(true);

    try {
      await axios.patch(
        `deliveries/${order.delivery.id}/update_status_history/${selectedHistoryStatus.id}/`,
        {
          details: newDetailText,
        },
      );

      fetchOrder();
      setOpenDetailModal(false);
      setNewDetailText("");
      setSelectedHistoryStatus(null);
    } catch (error) {
      console.error("Error al actualizar el detalle del estado:", error);
      setMessageAlert("Ocurrió un error al actualizar el detalle");
      setOpenErrorAlert(true);
    } finally {
      setSubmitDetailLoading(false);
    }
  };

  return loading ? (
    <CircularProgress className="loading-btn" />
  ) : loadingError !== "" ? (
    <Alert severity="error">{loadingError}</Alert>
  ) : (
    <>
      <div style={{ padding: "20px" }}>
        {/* Parte Superior */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "20px",
          }}
        >
          <Button
            variant="outlined"
            style={{ marginRight: "10px" }}
            onClick={() => navigate(-1)}
          >
            ← Regresar
          </Button>
          <Typography variant="h5">{order.reference_id}</Typography>
          {order.external_pack_id && (
            <Typography variant="h5">-{order.external_pack_id}</Typography>
          )}
        </div>

        {/* Etiquetas de Tipo y Estado */}
        <div
          style={{
            marginBottom: "20px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <Chip
              variant="contained"
              label={get_order_type_label(order.type)}
              style={{ marginRight: "10px" }}
            />
            {/* <Chip variant="contained" label={get_order_status_label(order.mixed_status, order.type)} style={{ marginRight: '10px' }} /> */}
            <Chip
              variant="contained"
              label={get_order_source_label(order.source)}
              style={{ marginRight: "10px" }}
            />
          </div>
          <div>
            <Button
              type="submit"
              variant="contained"
              onClick={handleFulfillOrder}
            >
              <InventoryIcon fontSize="small" /> Preparar envío
            </Button>

            <Button
              type="submit"
              variant="contained"
              onClick={handleDownloadLabel}
              style={{ marginLeft: "5px" }}
            >
              <DownloadIcon fontSize="small" /> Descargar Etiqueta
            </Button>
          </div>
        </div>

        <Box sx={{ width: "100%" }}>
          <Grid
            container
            rowSpacing={2}
            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
          >
            <Grid item xs={7}>
              {/* Información de Productos */}
              <Grid
                container
                rowSpacing={2}
                columnSpacing={{ xs: 1, sm: 2, md: 3 }}
              >
                {/* Información de Productos e Interfaz de Picking */}
                <Grid item xs={12}>
                  <Card
                    variant="outlined"
                    sx={{ borderRadius: 3, border: "1px solid #e0e0e0" }}
                  >
                    <CardContent sx={{ p: 2 }}>
                      <Typography variant="h6" sx={{ mb: 3, color: "#333" }}>
                        {originCountry} {order.seller.company.social_reason}
                      </Typography>

                      <List disablePadding>
                        {order.products.map((item) => {
                          const currentQty = pickingQuantities[item.id] || 0;
                          const isFullyPrepared =
                            item.status === "prepared" ||
                            item.prepared_quantity === item.quantity;
                          const isSubmitting = submittingProductId === item.id;

                          return (
                            <ListItem
                              key={item.id}
                              sx={{
                                mb: 2,
                                py: 0,
                                px: 0,
                                bgcolor: isFullyPrepared
                                  ? "#f9fcf8"
                                  : "#ffffff",
                                opacity: isFullyPrepared ? 0.8 : 1,
                              }}
                            >
                              <Grid container alignItems="center" spacing={2}>
                                {/* Información del ítem */}
                                <Grid item xs={12} md={7}>
                                  <ListItemText
                                    primary={
                                      <Typography
                                        variant="h7"
                                        sx={{ mb: 0.5 }}
                                      >
                                        {item.product.name}
                                      </Typography>
                                    }
                                    secondary={`SKU: ${item.product.sku} | Cantidad: ${item.quantity} | Peso: ${item.product.weight}`}
                                    secondaryTypographyProps={{
                                      fontSize: "0.85rem",
                                      color: "#666",
                                    }}
                                  />
                                </Grid>

                                {(hasFulfillmentLite || hasFulfillmentPro) && (
                                  <>
                                    {/* Controles del Contador (+ / -) */}
                                    <Grid
                                      item
                                      xs={6}
                                      md={3}
                                      display="flex"
                                      alignItems="center"
                                      justifyContent="center"
                                      gap={1}
                                      sx={{
                                        paddingTop: "16px !important",
                                      }}
                                    >
                                      <IconButton
                                        onClick={() =>
                                          handleDecrementQuantity(item.id)
                                        }
                                        disabled={
                                          currentQty === 0 ||
                                          isFullyPrepared ||
                                          isSubmitting
                                        }
                                        sx={{
                                          bgcolor: "#ffebee",
                                          color: "#d32f2f",
                                          border: "1px solid #ffcdd2",
                                          width: "36px !important",
                                          height: "36px !important",
                                          "&:hover": { bgcolor: "#ffcdd2" },
                                          "&.Mui-disabled": {
                                            bgcolor: "#f5f5f5",
                                            border: "1px solid #e0e0e0",
                                          },
                                        }}
                                      >
                                        <Typography variant="h6" lineHeight={1}>
                                          -
                                        </Typography>
                                      </IconButton>

                                      <Typography
                                        variant="h6"
                                        sx={{
                                          minWidth: "24px",
                                          textAlign: "center",
                                          fontWeight: "bold",
                                          color: isFullyPrepared
                                            ? "#9e9e9e"
                                            : "#000",
                                        }}
                                      >
                                        {currentQty}
                                      </Typography>

                                      <IconButton
                                        onClick={() =>
                                          handleIncrementQuantity(
                                            item.id,
                                            item.quantity,
                                          )
                                        }
                                        disabled={
                                          currentQty >= item.quantity ||
                                          isFullyPrepared ||
                                          isSubmitting
                                        }
                                        sx={{
                                          bgcolor: "#e8f5e9",
                                          color: "#2e7d32",
                                          border: "1px solid #c8e6c9",
                                          width: "36px !important",
                                          height: "36px !important",
                                          "&:hover": { bgcolor: "#c8e6c9" },
                                          "&.Mui-disabled": {
                                            bgcolor: "#f5f5f5",
                                            border: "1px solid #e0e0e0",
                                          },
                                        }}
                                      >
                                        <Typography variant="h6" lineHeight={1}>
                                          +
                                        </Typography>
                                      </IconButton>
                                    </Grid>

                                    <Grid
                                      item
                                      xs={6}
                                      md={2}
                                      display="flex"
                                      justifyContent="flex-end"
                                    >
                                      <Button
                                        variant={
                                          isFullyPrepared
                                            ? "outlined"
                                            : "contained"
                                        }
                                        color={
                                          isFullyPrepared
                                            ? "success"
                                            : "inherit"
                                        }
                                        onClick={() =>
                                          handlePrepareProductIndividual(
                                            item.id,
                                          )
                                        }
                                        disabled={
                                          currentQty === 0 ||
                                          isFullyPrepared ||
                                          isSubmitting
                                        }
                                        sx={{
                                          textTransform: "uppercase",
                                          fontWeight: "bold",
                                          minWidth: "80px !important",
                                          fontSize: "14px !important",
                                          bgcolor:
                                            !isFullyPrepared && currentQty > 0
                                              ? "#ffffff"
                                              : undefined,
                                          color:
                                            !isFullyPrepared && currentQty > 0
                                              ? "#ffffff"
                                              : undefined,
                                          border:
                                            !isFullyPrepared && currentQty > 0
                                              ? "1px solid #ccc"
                                              : undefined,
                                        }}
                                      >
                                        {isSubmitting ? (
                                          <CircularProgress
                                            size={20}
                                            color="inherit"
                                          />
                                        ) : isFullyPrepared ? (
                                          "Preparado"
                                        ) : (
                                          "Preparar"
                                        )}
                                      </Button>
                                    </Grid>
                                  </>
                                )}
                              </Grid>
                            </ListItem>
                          );
                        })}
                      </List>
                    </CardContent>
                  </Card>
                </Grid>

                {/* Información del Destinatario */}
                <Grid item xs={12}>
                  <Card variant="outlined">
                    <CardContent>
                      <Typography variant="h6">
                        {" "}
                        Información de Entrega
                      </Typography>
                      <Grid
                        container
                        rowSpacing={1}
                        columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                      >
                        <Grid item xs={5}>
                          <Typography>Id Seller</Typography>
                        </Grid>
                        <Grid item xs={7}>
                          <Typography>{order.seller.id}</Typography>
                        </Grid>
                        <Grid item xs={5}>
                          <Typography>Id Ninjahubs</Typography>
                        </Grid>
                        <Grid item xs={7}>
                          <Typography>{order.id}</Typography>
                        </Grid>
                        <Grid item xs={5}>
                          <Typography>Tipo de Orden</Typography>
                        </Grid>
                        <Grid item xs={7}>
                          <Typography>
                            {get_order_type_label(order.type)}
                          </Typography>
                        </Grid>
                        {(order.type === "delivery" ||
                          order.type === "delivery_fulfillment" ||
                          order.type === "pick_up" ||
                          order.type === "pick_up_fulfillment" ||
                          order.type === "delivery_return") && (
                          <>
                            <Grid item xs={5}>
                              <Typography>Tipo de Entrega</Typography>
                            </Grid>
                            <Grid item xs={7}>
                              <Typography>
                                {order.delivery?.shipping_method
                                  ? get_order_shipping_method_label(
                                      order.delivery?.shipping_method,
                                    )
                                  : "-"}
                              </Typography>
                            </Grid>
                            {user?.admin_plan?.plan_type ===
                            "admin_checkout" ? (
                              <>
                                <Grid item xs={5}>
                                  <Typography>Despachador</Typography>
                                </Grid>
                                <Grid item xs={7}>
                                  <Typography>
                                    {order.delivery?.driver?.full_name ||
                                      "Sin conductor asignado"}
                                  </Typography>
                                </Grid>
                              </>
                            ) : null}
                            {(isAdmin || isSeller) && (
                              <>
                                <Grid item xs={5}>
                                  <Typography>Bodega</Typography>
                                </Grid>
                                <Grid item xs={7}>
                                  <Typography>
                                    {order.warehouse
                                      ? order.warehouse.name
                                      : "Sin bodega asociada"}
                                  </Typography>
                                </Grid>
                              </>
                            )}

                            <Grid item xs={5}>
                              <Typography>Dirección de Entrega</Typography>
                            </Grid>
                            <Grid item xs={7}>
                              <Typography>
                                {order.delivery?.shipping_address
                                  ? get_full_address(
                                      order.delivery?.shipping_address,
                                    )
                                  : "-"}
                              </Typography>
                            </Grid>
                            <Grid item xs={5}>
                              <Typography>Notas</Typography>
                            </Grid>
                            <Grid item xs={7}>
                              <Typography>
                                {order.notes ? order.notes : "Sin notas"}
                              </Typography>
                            </Grid>
                            <Grid item xs={5}>
                              <Typography>Proveedor de la Entrega</Typography>
                            </Grid>
                            <Grid item xs={7}>
                              {/* {order.delivery?.status === "waiting_for_assignment" &&
                              availableCouriers.length > 0 ? ( */}
                              {/* #comentario: con esto queda filtrado por estado "pendiente de asignación" */}
                              {hasFulfillmentPro && availableCouriers.length > 0 ? (
                                <Autocomplete
                                  size="small"
                                  options={availableCouriers}
                                  getOptionLabel={(opt) => opt.courier ?? ""}
                                  isOptionEqualToValue={(opt, val) =>
                                    opt.courier === val?.courier
                                  }
                                  value={
                                    selectedCourier ??
                                    availableCouriers.find(
                                      (c) =>
                                        c.courier ===
                                        order.delivery?.shipping_zone?.courier,
                                    ) ??
                                    null
                                  }
                                  onChange={(_, newVal) =>
                                    handleCourierChange(newVal)
                                  }
                                  disabled={changingCourier}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      label="Courier"
                                      size="small"
                                    />
                                  )}
                                  sx={{ minWidth: 180 }}
                                />
                              ) : (
                                <Typography>
                                  {order.delivery
                                    ? get_order_provider(order.delivery)
                                    : "-"}
                                </Typography>
                              )}
                            </Grid>
                            <Grid item xs={5}>
                              <Typography>Fecha de creación</Typography>
                            </Grid>
                            <Grid item xs={7}>
                              <Typography>
                                {order.created_at
                                  ? strDateFormatWithTime(
                                      new Date(order.created_at),
                                    )
                                  : "-"}
                              </Typography>
                            </Grid>
                            <Grid item xs={5}>
                              <Typography>Promesa de entrega</Typography>
                            </Grid>
                            <Grid item xs={7}>
                              <Typography>
                                {order.promised_date
                                  ? strDateFormatWithTime(
                                      new Date(order.promised_date),
                                    )
                                  : "-"}
                              </Typography>
                            </Grid>
                            <Grid item xs={5}>
                              <Typography>Número de Trackeo</Typography>
                            </Grid>
                            <Grid item xs={7}>
                              <Typography>
                                {order.delivery?.master_tracking_number ?? "-"}
                              </Typography>
                            </Grid>
                            <Grid item xs={5}>
                              <Typography>URL tracking</Typography>
                            </Grid>
                            <Grid item xs={7}>
                              <Typography>
                                {order.delivery?.url_tracking ? (
                                  <Button
                                    onClick={(event) => {
                                      event.preventDefault();
                                      window.open(
                                        order.delivery.url_tracking,
                                        "_blank",
                                        "noopener,noreferrer",
                                      ); // Opens the URL in a new tab
                                    }}
                                    variant="contained"
                                    sx={{
                                      backgroundColor: "#25D366", // WhatsApp green color
                                      color: "#FFFFFF", // White text
                                      textTransform: "none", // Keeps the text as "Tracking pedido" without uppercase
                                      padding: "8px 16px", // Adjust padding for button style
                                      borderRadius: "4px", // Rounds the corners slightly
                                      boxShadow: "none", // Removes extra shadow for a cleaner look
                                      "&:hover": {
                                        backgroundColor: "#1ebe5b", // Slightly darker green on hover
                                        boxShadow: "none", // Prevents hover shadow
                                      },
                                    }}
                                  >
                                    Tracking Courier
                                  </Button>
                                ) : (
                                  "-"
                                )}
                              </Typography>
                            </Grid>
                            <Grid item xs={5}>
                              <Typography>Bultos</Typography>
                            </Grid>
                            <Grid item xs={7}>
                              <Typography>
                                {order.delivery?.packages &&
                                order.delivery.packages.trim() !== ""
                                  ? order.delivery.packages
                                  : "1"}
                              </Typography>
                            </Grid>

                            <Grid item xs={5}>
                              <Typography>Peso (gramos)</Typography>
                            </Grid>
                            <Grid item xs={7}>
                              <Typography>
                                {order.delivery?.weight &&
                                order.delivery.weight.trim() !== ""
                                  ? order.delivery.weight
                                  : "1000"}
                              </Typography>
                            </Grid>

                            <Grid item xs={5}>
                              <Typography>Seguimiento</Typography>
                            </Grid>
                            <Grid item xs={7}>
                              <Button
                                onClick={(event) => {
                                  event.preventDefault();
                                  window.open(
                                    `/track-order/${orderId}`,
                                    "_blank",
                                    "noopener,noreferrer",
                                  ); // Opens the tracking page in a new tab
                                }}
                                variant="contained"
                                sx={{
                                  backgroundColor: "#25D366", // WhatsApp green color
                                  color: "#FFFFFF", // White text
                                  textTransform: "none", // Keeps the text as "Consultas" without uppercase
                                  padding: "8px 16px", // Adjust padding for button style
                                  borderRadius: "4px", // Rounds the corners slightly
                                  boxShadow: "none", // Removes extra shadow for a cleaner look
                                  "&:hover": {
                                    backgroundColor: "#1ebe5b", // Slightly darker green on hover
                                    boxShadow: "none", // Prevents hover shadow
                                  },
                                }}
                              >
                                Tracking pedido
                              </Button>
                            </Grid>
                          </>
                        )}
                        {order.type === "click_collect" && (
                          <>
                            <Grid item xs={5}>
                              <Typography>Punto de Retiro</Typography>
                            </Grid>
                            <Grid item xs={7}>
                              <Typography>
                                {order.warehouse?.name ?? "-"}
                              </Typography>
                            </Grid>
                            <Grid item xs={5}>
                              <Typography>Dirección de Retiro</Typography>
                            </Grid>
                            <Grid item xs={7}>
                              <Typography>
                                {order.warehouse?.address
                                  ? get_full_address(order.warehouse?.address)
                                  : "-"}
                              </Typography>
                            </Grid>
                          </>
                        )}
                      </Grid>
                      <Button
                        variant="outlined"
                        color="primary"
                        style={{ marginTop: "10px" }}
                        onClick={() => setOpenEditOrderInfo(true)}
                        disabled={!canEditOrderInfo}
                        className={!canEditOrderInfo ? "button-disabled" : ""}
                      >
                        Editar
                      </Button>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={5}>
              {/* Información de Entrega */}
              <Grid
                container
                rowSpacing={2}
                columnSpacing={{ xs: 1, sm: 2, md: 3 }}
              >
                <Grid item xs={12}>
                  <Card variant="outlined" style={{ marginBottom: "20px" }}>
                    <CardContent>
                      <Typography variant="h6">Destinatario</Typography>
                      <Grid
                        container
                        rowSpacing={1}
                        columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                      >
                        <Grid item xs={4}>
                          <Typography>Nombre</Typography>
                        </Grid>
                        <Grid item xs={8}>
                          <Typography>{order.recipient}</Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography>Mail</Typography>
                        </Grid>
                        <Grid item xs={8}>
                          <Typography>{order.contact_email}</Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography>Teléfono</Typography>
                        </Grid>
                        <Grid item xs={8}>
                          <Typography>{order.contact_phone}</Typography>
                        </Grid>
                      </Grid>
                      <Button
                        variant="outlined"
                        color="primary"
                        style={{ marginTop: "10px" }}
                        onClick={() => setOpenEditRecipientInfo(true)}
                      >
                        Editar
                      </Button>
                    </CardContent>
                  </Card>
                </Grid>
                {isAdmin && (
                  <Grid item xs={12}>
                    <Card variant="outlined" style={{ marginBottom: "20px" }}>
                      <CardContent>
                        <Typography variant="h6">Estado entrega</Typography>
                        <Button
                          variant="outlined"
                          color="primary"
                          style={{ marginTop: "10px" }}
                          onClick={() => setOpenEditStatus(true)}
                        >
                          Editar
                        </Button>
                      </CardContent>
                    </Card>
                  </Grid>
                )}

                {/* Timeline - DeliveryStatusHistory */}
                <Grid item xs={12}>
                  <Timeline
                    sx={{
                      m: 0,
                      p: 0,
                      [`& .MuiTimelineItem-root::before`]: {
                        flex: 0,
                        padding: 0,
                      },
                    }}
                  >
                    {filteredStatuses.map((status) => {
                      const statusText = status.friendlySubStatus
                        ? `${status.friendlyStatus}: ${status.friendlySubStatus}`
                        : status.friendlyStatus;

                      return (
                        <TimelineItem key={status.date}>
                          <TimelineSeparator>
                            <TimelineDot sx={{ backgroundColor: "#00e1be" }} />
                            <TimelineConnector />
                          </TimelineSeparator>

                          <TimelineContent sx={{ py: 1.5, px: 2 }}>
                            <Typography variant="body2" color="text.secondary">
                              {strDateFormatWithTime(new Date(status.date))}
                            </Typography>

                            <Box
                              display="flex"
                              alignItems="center"
                              gap={1}
                              sx={{ my: 0.5 }}
                            >
                              <Typography
                                variant="h7"
                              >
                                {statusText}
                              </Typography>

                              {isAdmin && (
                                <IconButton
                                  size="small"
                                  sx={{
                                    border: "1px solid #00e1be",
                                    color: "#00e1be",
                                    padding: "0px !important",
                                    minWidth: "40px !important",
                                    minHeight: "40px !important",
                                  }}
                                  onClick={() => {
                                    setSelectedHistoryStatus(status);
                                    setNewDetailText(status.details || "");
                                    setOpenDetailModal(true);
                                  }}
                                >
                                  <EditIcon sx={{ fontSize: "1rem" }} />
                                </IconButton>
                              )}
                            </Box>

                            {status.details && (
                              <Typography variant="body2" sx={{ mb: 1 }}>
                               Detalles Entrega: {status.details}
                              </Typography>
                            )}

                            {/* Thumbnails Section */}
                            {status.image_urls &&
                              status.image_urls.length > 0 && (
                                <Box
                                  display="flex"
                                  flexWrap="wrap"
                                  gap={1}
                                  mt={1}
                                >
                                  {status.image_urls.map((url, index) => (
                                    <img
                                      key={index}
                                      src={url}
                                      alt={`status-thumbnail-${index}`}
                                      style={{
                                        width: 40,
                                        height: 40,
                                        objectFit: "cover",
                                        borderRadius: 4,
                                        border: "1px solid #ddd",
                                        cursor: "pointer",
                                      }}
                                      onClick={() => handleImageClick(url)}
                                    />
                                  ))}
                                </Box>
                              )}
                            {isAdmin && (
                              status.source && (
                                <Typography variant="body2" sx={{ mb: 1 }}>
                                <b>Source:</b> {status.source}
                                </Typography>
                              )
                             )}
                            {isAdmin && (
                              status.external_source && (
                                <Typography variant="body2" sx={{ mb: 1 }}>
                                <b>External Source:</b> {status.external_source}
                                </Typography>
                              )
                             )}

                          </TimelineContent>
                        </TimelineItem>
                      );
                    })}
                  </Timeline>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>

        <DeliveryItems
          delivery={order.delivery}
          deliveryItems={deliveryItems}
          deliveryItemsCount={deliveryItemsCount}
          pagination={pagination}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          createDeliveryItem={createDeliveryItem}
          deleteDeliveryItem={deleteDeliveryItem}
          updateDeliveryItemStatus={updateDeliveryItemStatus}
          updateDeliveryItemLogistics={updateDeliveryItemLogistics}
          setItemsCount={setItemsCount}
          onDispatchPrepared={handleDispatchPrepared}
          loading={loadingDeliveryItems}
          error={errorDeliveryItem}
          onItemsUpdated={fetchOrder}
          orderProducts={order.products || []}
        />
      </div>

      {/* Diálogo para edición  info orden CL/MX*/}
      <Dialog
        open={openEditOrderInfo}
        onClose={() => setOpenEditOrderInfo(false)}
      >
        <DialogTitle>Editar Información de Entrega {originCountry}</DialogTitle>
        <DialogContent>
          <form noValidate autoComplete="off">
            <Autocomplete
              fullWidth
              id="shipping-select"
              options={shippingMethodEnumChoices}
              getOptionLabel={(shippingMethod) =>
                shippingMethod ? shippingMethod.label : ""
              }
              isOptionEqualToValue={(option, value) =>
                option.value === value?.value
              } // Compare by 'value'
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Tipo de Envío"
                  helperText={
                    submitEditOrderInfo &&
                    selectedShippingMethod == null &&
                    "Campo obligatorio"
                  }
                  error={submitEditOrderInfo && selectedShippingMethod == null}
                />
              )}
              value={selectedShippingMethod}
              onChange={(event, newValue) =>
                setSelectedShippingMethod(newValue)
              }
            />
            {user.admin_plan?.plan_type === "admin_checkout" ? (
              <>
                <Autocomplete
                  fullWidth
                  id="drivers-select"
                  options={driversChoices(drivers)}
                  getOptionLabel={(driver) => (driver ? driver.label : "")}
                  isOptionEqualToValue={(option, value) =>
                    option.value === value?.value
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Despachador"
                      error={submitEditOrderInfo}
                    />
                  )}
                  value={selectedDriver}
                  onChange={(event, newValue) => setSelectedDriver(newValue)}
                />
              </>
            ) : null}
            <Autocomplete
              fullWidth
              id="shipping-select"
              options={warehouses}
              getOptionLabel={(warehouses) =>
                warehouses ? warehouses.name : ""
              }
              isOptionEqualToValue={(option, value) =>
                option.value === value?.value
              } // Compare by 'value'
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Bodega origen"
                  helperText={
                    submitEditOrderInfo &&
                    selectedWarehouse === null &&
                    "Campo obligatorio"
                  }
                  error={submitEditOrderInfo && selectedWarehouse === null}
                />
              )}
              value={selectedWarehouse}
              onChange={(event, newValue) => setSelectedWarehouse(newValue)}
            />

            <TextField
              fullWidth
              error={submitEditOrderInfo && street === ""}
              variant="outlined"
              label="Calle"
              name="street"
              value={street}
              onChange={(e) => setStreet(e.target.value)}
              helperText={
                submitEditOrderInfo && street === "" ? "Campo obligatorio" : ""
              }
            />

            <TextField
              fullWidth
              error={submitEditOrderInfo && streetNumber === ""}
              variant="outlined"
              label="Número"
              name="street_number"
              value={streetNumber}
              onChange={(e) => setStreetNumber(e.target.value)}
              helperText={
                submitEditOrderInfo &&
                streetNumber === "" &&
                "Campo obligatorio"
              }
            />
            {originCountry == "(CL)" ? (
              <>
                <Autocomplete
                  fullWidth
                  id="region-select"
                  options={regionsOptions}
                  getOptionLabel={(region) => (region ? region.label : "")}
                  isOptionEqualToValue={(option, value) =>
                    option.value === value?.value
                  } // Compare by 'value'
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Región"
                      helperText={
                        submitEditOrderInfo &&
                        selectedRegion === null &&
                        "Campo obligatorio"
                      }
                      error={submitEditOrderInfo && selectedRegion === null}
                    />
                  )}
                  value={selectedRegion}
                  onChange={(event, newValue) =>
                    handleSelectRegion(event, newValue)
                  }
                />
                <Autocomplete
                  fullWidth
                  id="communes-select"
                  options={communesOptions}
                  getOptionLabel={(commune) => (commune ? commune.label : "")}
                  isOptionEqualToValue={(option, value) =>
                    option.value === value?.value
                  } // Compare by 'value'
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Comuna"
                      helperText={
                        submitEditOrderInfo &&
                        selectedCommune === null &&
                        "Campo obligatorio"
                      }
                      error={submitEditOrderInfo && selectedCommune === null}
                    />
                  )}
                  value={selectedCommune}
                  onChange={(event, newValue) => setSelectedCommune(newValue)}
                />
              </>
            ) : null}
            {originCountry == "(MX)" ? (
              <>
                <TextField
                  fullWidth
                  error={submitEditOrderInfo && mxCommune === null}
                  variant="outlined"
                  label="Comuna"
                  name="mxCommune"
                  value={mxCommune}
                  onChange={(e) => setMxCommune(e.target.value)}
                  helperText={submitEditOrderInfo && mxCommune === null}
                />

                <TextField
                  fullWidth
                  error={submitEditOrderInfo && mxSettlement === null}
                  variant="outlined"
                  label="Colonia"
                  name="mxSettlement"
                  value={mxSettlement}
                  onChange={(e) => setMxSettlement(e.target.value)}
                  helperText={submitEditOrderInfo && mxSettlement === null}
                />

                <TextField
                  fullWidth
                  error={submitEditOrderInfo && mxState === null}
                  variant="outlined"
                  label="Estado"
                  name="mxState"
                  value={mxState}
                  onChange={(e) => setMxState(e.target.value)}
                  helperText={submitEditOrderInfo && mxState === null}
                />

                <TextField
                  fullWidth
                  error={submitEditOrderInfo && mxPostalCode === null}
                  variant="outlined"
                  label="Código Postal"
                  name="postal_code"
                  value={mxPostalCode}
                  onChange={(e) => setMxPostalCode(e.target.value)}
                  helperText={submitEditOrderInfo && mxPostalCode === null}
                />
              </>
            ) : null}
            <TextField
              fullWidth
              error={submitEditOrderInfo && notes === null}
              variant="outlined"
              label="Notas"
              name="notes"
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              helperText={submitEditOrderInfo && notes === null}
            />

            <TextField
              fullWidth
              type="number"
              variant="outlined"
              label="Peso (gramos)"
              name="weight"
              value={weight}
              onChange={(e) => setWeight(Number(e.target.value))}
              inputProps={{ min: 1 }}
              error={submitEditOrderInfo && (!weight || weight < 1)}
              helperText={
                submitEditOrderInfo && (!weight || weight < 1)
                  ? "Debe ser mínimo 1 gramo"
                  : ""
              }
            />
            <Button
              variant="contained"
              color="primary"
              style={{ marginTop: "10px" }}
              onClick={handleSaveEditOrderInfo}
            >
              Guardar
            </Button>
          </form>
        </DialogContent>
      </Dialog>

      {/* Diálogo para edición  info destinatario*/}
      <Dialog
        open={openEditRecipientInfo}
        onClose={() => setOpenEditRecipientInfo(false)}
      >
        <DialogTitle>Editar Destinatario</DialogTitle>
        <DialogContent>
          <form noValidate autoComplete="off">
            <TextField
              fullWidth
              error={submitEditRecipientInfo && recipientName === ""}
              variant="outlined"
              label="Nombre"
              name="name"
              value={recipientName}
              onChange={(e) => setRecipientName(e.target.value)}
              helperText={
                submitEditRecipientInfo && recipientName === ""
                  ? "Campo obligatorio"
                  : ""
              }
            />
            <TextField
              fullWidth
              error={
                (submitEditRecipientInfo && contactEmail === "") ||
                (contactEmail !== "" && !EmailValidator.validate(contactEmail))
              }
              variant="outlined"
              label="Mail"
              name="mail"
              value={contactEmail}
              onChange={(e) => setContactEmail(e.target.value)}
              helperText={
                submitEditRecipientInfo && contactEmail === ""
                  ? "Campo obligatorio"
                  : contactEmail !== "" &&
                      !EmailValidator.validate(contactEmail)
                    ? "Formato incorrecto"
                    : ""
              }
            />
            <InputMask
              mask="+56999999999"
              value={contactPhone}
              onChange={(e) => setContactPhone(e.target.value)}
              disabled={false}
              maskChar=" "
            >
              {() => (
                <TextField
                  fullWidth
                  error={submitEditRecipientInfo && contactPhone === ""}
                  variant="outlined"
                  label="Teléfono"
                  name="contactPhone"
                  helperText={
                    submitEditRecipientInfo && contactPhone === ""
                      ? "Campo obligatorio"
                      : ""
                  }
                />
              )}
            </InputMask>
            <Button
              variant="contained"
              color="primary"
              style={{ marginTop: "10px" }}
              onClick={handleSaveRecipientInfo}
            >
              Guardar
            </Button>
          </form>
        </DialogContent>
      </Dialog>

      {/* ADMIN: Diálogo para edición estado delivery*/}

      <Dialog
        open={openEditStatus}
        onClose={() => {
          setOpenEditStatus(false); // Close the modal
          resetStatusEditForm(); // Reset inputs
        }}
      >
        <DialogTitle>Editar Estado</DialogTitle>
        <DialogContent>
          <form noValidate autoComplete="off">
            <Autocomplete
              fullWidth
              id="shipping-select"
              options={deliveryStatusEnum}
              getOptionLabel={(deliveryStatus) =>
                deliveryStatus ? deliveryStatus.label : ""
              }
              isOptionEqualToValue={(option, value) =>
                option.value === value?.value
              } // Compare by 'value'
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="estado delivery"
                  helperText={
                    submitEditDeliveryStatus &&
                    selectedDeliveryStatus === null &&
                    "Campo obligatorio"
                  }
                  error={
                    submitEditDeliveryStatus && selectedDeliveryStatus === null
                  }
                />
              )}
              value={selectedDeliveryStatus}
              onChange={(event, newValue) =>
                handleSelectedDeliveryStatusChange(newValue)
              }
            />
            <Autocomplete
              fullWidth
              id="shipping-sub-select"
              options={deliverySubstatusOptions}
              getOptionLabel={(deliverySubstatus) =>
                deliverySubstatus ? deliverySubstatus.label : ""
              }
              isOptionEqualToValue={(option, value) =>
                option.value === value?.value
              } // Compare by 'value'
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="subestado delivery"
                  helperText={
                    submitEditDeliveryStatus &&
                    selectedDeliverySubstatus === null &&
                    "Campo obligatorio"
                  }
                  error={
                    submitEditDeliveryStatus &&
                    selectedDeliverySubstatus === null
                  }
                />
              )}
              value={selectedDeliverySubstatus}
              onChange={(event, newValue) =>
                setSelectedDeliverySubstatus(newValue)
              }
            />
            <TextField
              fullWidth
              variant="outlined"
              label="Detalle"
              name="detail"
              value={statusDetailComment}
              onChange={(e) => setStatusDetailComment(e.target.value)}
            />

            {uploading && (
              <CircularProgress size={24} style={{ marginLeft: 10 }} />
            )}
            {error && (
              <Typography color="error" variant="body2">
                {error}
              </Typography>
            )}

            {/* Image Uploader Section */}
            <Box style={{ marginBottom: "16px", marginTop: "26px" }}>
              <Typography variant="subtitle1" gutterBottom>
                (Máximo 3)
              </Typography>
              <Button
                variant="outlined"
                component="label"
                style={{ marginBottom: "10px" }}
              >
                Selecciona imágenes
                <input
                  type="file"
                  hidden
                  accept="image/png, image/jpeg" // Accept only PNG and JPG formats
                  multiple
                  onChange={(e) => handleImageSelect(e)}
                />
              </Button>

              {/* Preview Section */}
              <Box display="flex" flexWrap="wrap" gap={2}>
                {imageUrls.map((image, index) => (
                  <Box
                    key={index}
                    position="relative"
                    width={80}
                    height={80}
                    border="1px solid #ddd"
                    borderRadius={4}
                    overflow="hidden"
                  >
                    {/* Show Image Preview */}
                    <img
                      src={
                        typeof image === "string"
                          ? image // Use URL directly if it's a string
                          : URL.createObjectURL(image) // Use object URL for File objects
                      }
                      alt={`upload-preview-${index}`}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                    {/* Delete Button */}
                    <Button
                      size="small"
                      style={{
                        position: "absolute",
                        top: 4,
                        right: 4,
                        minWidth: 0,
                        padding: "2px",
                        color: "white",
                        backgroundColor: "red",
                        borderRadius: "50%",
                        fontSize: "12px",
                        lineHeight: 1,
                        opacity: 0.6,
                      }}
                      onClick={() => handleRemoveImage(index)}
                    >
                      &times;
                    </Button>
                  </Box>
                ))}
              </Box>
            </Box>

            <Button
              disabled={
                selectedDeliveryStatus === null ||
                selectedDeliveryStatus === "" ||
                selectedDeliverySubstatus === null ||
                selectedDeliverySubstatus === ""
              }
              variant="contained"
              color="primary"
              style={{ marginTop: "10px" }}
              onClick={handleSaveEditDeliveryStatus} //handleSaveEditDeliveryStatus
            >
              Guardar Estado
            </Button>
          </form>
        </DialogContent>
      </Dialog>
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={6000}
        onClose={handleCloseAlert}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert severity="error" sx={{ width: "100%" }}>
          {messageAlert}
        </Alert>
      </Snackbar>

      {/* Modal for Detailed Image View */}
      <Dialog open={openModal} onClose={handleCloseModal} maxWidth="md">
        <DialogContent>
          {selectedImage && (
            <Box
              component="img"
              src={selectedImage}
              alt="Detailed POD Image"
              sx={{ width: "100%", height: "auto", borderRadius: 1 }}
            />
          )}
        </DialogContent>
      </Dialog>

      <Dialog
        open={openDispatchConfirm}
        onClose={handleCancelDispatch}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Confirmar despacho inmediato</DialogTitle>
        <DialogContent>
          <Typography>
            El courier <b>{pendingCourierChange?.courier}</b> no tiene stand-by
            activo. El pedido se enviará de inmediato al TMS. ¿Confirmar?
          </Typography>
          <Box display="flex" justifyContent="flex-end" gap={1} marginTop={2}>
            <Button onClick={handleCancelDispatch} color="inherit">
              Cancelar
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handleConfirmDispatch}
            >
              Confirmar
            </Button>
          </Box>
        </DialogContent>
      </Dialog>

      <Dialog
        open={openDetailModal}
        onClose={() => setOpenDetailModal(false)}
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle>Editar Detalle del Estado</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            rows={3}
            variant="outlined"
            label="Detalle / Observación"
            value={newDetailText}
            onChange={(e) => setNewDetailText(e.target.value)}
            style={{ marginTop: "15px", width: "100%" }}
          />
          <Box display="flex" justifyContent="flex-end" marginTop={2} gap={1}>
            <Button
              onClick={() => setOpenDetailModal(false)}
              color="inherit"
              disabled={submitDetailLoading}
            >
              Cancelar
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSaveStatusDetail}
              disabled={submitDetailLoading}
            >
              {submitDetailLoading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                "Guardar"
              )}
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default OrderDetail;
